import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { FCM } from '@ionic-native/fcm';
import { Badge } from '@ionic-native/badge';
import firebase from 'firebase';

import { GlobalServiceProvider, UserServiceProvider, CameraService, StorageServiceProvider, FbProvider, CustomerServiceProvider, IxomProvider, AuthProvider } from '../providers';
import { WeeklyNewsProvider } from '../pages/weekly-news/weekly-news-service';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  private tokenBTCustomerAPI: string = 'tokenBTCustomerAPI';
  userDetail: any = {};
  userINFO: any = {
    displayName: '',
    email: '',
    CompanyName: '',
    customerNo: '',
    photoURL: 'assets/imgs/profile.jpg'
  };
  rootPage: any;
  pages: Array<{ title: string, component: any, icon: string }>;
  constructor(public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public fb: FbProvider,
    public events: Events,
    public globalServiceProvider: GlobalServiceProvider,
    public userServiceProvider: UserServiceProvider,
    private cameraService: CameraService,
    public alertCtrl: AlertController,
    public storageServiceProvider: StorageServiceProvider,
    public fcm: FCM,
    private customerServiceProvider: CustomerServiceProvider,
    private badge: Badge,
    private weeklyNewsProvider: WeeklyNewsProvider,
    private ixomProvider: IxomProvider,
    private authProvider: AuthProvider
  ) {
    this.events.subscribe('infoProfile', (result) => {
      if (result) {
        this.userDetail = this.userServiceProvider.loadLoginUserData();   
        this.userINFO = {
          displayName: result.FirstName + ' ' + result.LastName,
          CompanyName: result.CompanyName,
          customerNo: result.customerNo,
          email: result.email.toLowerCase(),
          photoURL: result.photoURL
        };
        this.settingMenu(result);
      }
    });
    this.initializeApp(fb);

  }

  initializeApp(firebaseAuth: FbProvider) {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(false);
      this.splashScreen.hide();

      if (this.platform.is('cordova')) {
        this.badge.clear();
        this.fcm.subscribeToTopic('weeklynews');
        //**
        // * FCM initialize
        // */
        this.fcm.onNotification().subscribe(data => {
          console.log('onNotification: ', data);
          if (data.wasTapped) {
            this.badge.clear();
            console.log("Received in background");
          } else {
            console.log("Received in foreground");
            this.alertCtrl.create({
              title: data.title,
              subTitle: data.body,
              buttons: ['OK']
            }).present();
          };
        });

        this.fcm.onTokenRefresh().subscribe(token => {
          // backend.registerToken(token);
        });
      }
      
      firebaseAuth.init();
      const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
        var token = this.storageServiceProvider.getToken(this.tokenBTCustomerAPI);
        if (!user || !token) {
          this.rootPage = this.globalServiceProvider.SET_PAGE_LOGIN();
          unsubscribe();
        } else {
          this.userDetail = this.userServiceProvider.loadLoginUserData();        
          const result: any = await this.authProvider.getUser(this.userDetail.email.toLowerCase());
          if(!result || (result && result.user && result.user.Active === false)){
            this.logoutUser();
            return;
          }
          console.log('1-------userCus: ', result);
          this.storageServiceProvider.setToken(this.tokenBTCustomerAPI, result.token);
          this.userDetail = this.userServiceProvider.loadLoginUserData();
          this.userINFO = {
            displayName: (this.userDetail.FirstName || '') + ' ' + (this.userDetail.LastName || ''),
            CompanyName: this.userDetail.CompanyName,
            customerNo: this.userDetail.customerNo,
            email: this.userDetail.email.toLowerCase()
          };
          if (user.photoURL) {
            this.userINFO.photoURL = user.photoURL;
          };

          console.log('userDetail: ', this.userDetail);
          this.settingMenu(this.userDetail);
          // if (this.isIxom === true) {
          //   this.nav.setRoot('IxomDashboardV2Page');
          // } else if (this.userDetail && this.userDetail.isM2X && this.userDetail.isM2X === true) {
          //   this.nav.setRoot('NewStaticDashboardPage');
          // } else {
          //   this.nav.setRoot('DashboardPage');
          // }
          this.nav.setRoot('NewStaticDashboardPage');
          unsubscribe();
        }
      });
    });
  }

  logoutUser() {
    firebase.auth().signOut()
      .then(() => {
        this.nav.setRoot(this.globalServiceProvider.SET_PAGE_LOGIN());
        this.customerServiceProvider.setUpcomingJobs = null;
        this.customerServiceProvider.setCurrentJobs = null;
        this.customerServiceProvider.setCompleteJobs = null;
        this.customerServiceProvider.setIncomingJobs = null;
        this.customerServiceProvider.setConsignmentLegList = null;
        this.weeklyNewsProvider.weeklynews = null;
        this.ixomProvider.ixomsSchedule = null;
      }, (error) => {
        console.log(error)
      })
  }

  openPage(title, component) {
    console.log('page: ' + title);
    if (title === 'Sign Out') {
      this.logoutUser();
    } else {
      this.nav.setRoot(component);
    }
  }

  openPageDashboard() {
    // if (this.isIxom === true) {
    //   this.nav.setRoot('IxomDashboardV2Page');
    // } else if (this.userDetail && this.userDetail.isM2X && this.userDetail.isM2X === true) {
    //   this.nav.setRoot('NewStaticDashboardPage');
    // } else {
    //   this.nav.setRoot('DashboardPage');
    // }
    this.nav.setRoot('NewStaticDashboardPage');
  }

  changeImageProfile() {
    console.log('Change Image Profile');    
    let currentUser = firebase.auth().currentUser;
    let prompt = this.alertCtrl.create({
      title: 'Choose',
      message: "<p>Take picture or use from library</p>",
      buttons: [
        {
          text: 'Camera',
          handler: data => {
            this.cameraService.captureImage(75, 75, 'camera').then(base64Image => {
              if (base64Image) {
                this.fb.uploadFileStorage(currentUser.uid, base64Image)
                .then(result => {
                  this.userINFO.photoURL = result.downloadURL;
                  this.fb.updateProfile(currentUser.displayName, result.downloadURL);
                  this.fb.updateUser(currentUser.uid, {avatarUrl: result.downloadURL});
                }).catch(error =>{
                  console.log('error: ', error);
                });   
              }
            }).catch(err => {
              console.log('err: ', err);
            });
          }
        },
        {
          text: 'Library',
          handler: data => {
            this.cameraService.captureImage(75, 75, 'library').then(base64Image => {
              if (base64Image) {
                this.fb.uploadFileStorage(currentUser.uid, base64Image)
                .then(result => {
                  this.userINFO.photoURL = result.downloadURL;
                  this.fb.updateProfile(currentUser.displayName, result.downloadURL);
                  this.fb.updateUser(currentUser.uid, {avatarUrl: result.downloadURL});
                }).catch(error =>{
                  console.log('error: ', error);
                });   
              }
            }).catch(err => {
              console.log('err: ', err);
            });
          }
        }
      ]
    });
    prompt.present();
  }

  settingMenu(userDetail) {
    console.log('userDetail: ', userDetail);    
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts